import { useState, useContext, useEffect } from "react";
import {
  Icon,
  SideSheet,
  Pane,
  BriefcaseIcon,
  TextInputField,
  Spinner,
  Button,
  AddIcon,
  TrashIcon,
  Heading,
  Paragraph,
  SelectField,
  Checkbox,
  Textarea,
  Tablist,
  Tab,
  FloppyDiskIcon,
  Text,
} from "evergreen-ui";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import {
  CaseReferral,
  CreateCase,
  ApplicantReferral,
} from "../../global/Types";
import { globalContext } from "../../global/Store";
import "../currencyWrap.css";
import { dataRepoContext } from "../../data-repo/DataRepo";
import moment from "moment";

export const ReferCase = (props: any) => {
  const { globalState, dispatch, globalFunctions } = useContext(globalContext);
  const { globalDataRepo } = useContext(dataRepoContext);

  const [applicant1NameInvalid, setApplicant1NameInvalid] = useState(false);
  const [applicant1PhoneInvalid, setApplicant1PhoneInvalid] = useState(false);
  const [applicant1AddressInvalid, setApplicant1AddressInvalid] =
    useState(false);
  const [applicant1TownInvalid, setApplicant1TownInvalid] = useState(false);
  const [applicant1PostcodeInvalid, setApplicant1PostcodeInvalid] =
    useState(false);
  const [
    applicant1EmploymentStatusInvalid,
    setApplicant1EmploymentStatusInvalid,
  ] = useState(false);
  const [
    applicant1OtherPropertyOwnedInvalid,
    setApplicant1OtherPropertyOwnedInvalid,
  ] = useState(false);
  const [
    applicant1OtherPropertySoldInvalid,
    setApplicant1OtherPropertySoldInvalid,
  ] = useState(false);
  const [propertyStatusIdInvalid, setPropertyStatusIdInvalid] = useState(false);
  const [developmentIdInvalid, setDevelopmentIdInvalid] = useState(false);
  const [purchasePriceInvalid, setPurchasePriceInvalid] = useState(false);
  const [plotNumberInvalid, setPlotNumberInvalid] = useState(false);
  const [managerNameInvalid, setManagerNameInvalid] = useState(false);
  const [depositLevelInvalid, setDepositLevelInvalid] = useState(false);
  const [serviceChargeInvalid, setServiceChargeInvalid] = useState(false);
  const [currentShareholdingsInvalid, setCurrentShareholdingsInvalid] =useState(false);
  const [remainingyearoncurrentleaseInvalid, setremainingyearoncurrentleaseInvalid] =useState(false);
  const [schemeInvalid, setSchemeInvalid] = useState(false);
  const [casetypeInvalid, setCasetypeInvalid] = useState(false);
  const [appointmentInvalid, setAppointmentInvalid] = useState(false);
  const [minPercShareInvalid, setMinPercShareInvalid] = useState(false);
  const [housingAssociationInvalid, setHousingAssociationInvalid] = useState(false);
  const [propertyTypeInvalid, setPropertyTypeInvalid] = useState(false);
  const [buyerTypeInvalid, setBuyerTypeInvalid] = useState(false);

  const [applicantsLoaded, setApplicantsLoaded] = useState(false);

  const [selectedIndex, setSelectedIndex] = useState<number | null>(0);
  const [caseReferral, setCaseReferral] = useState<CaseReferral>(
    {} as CaseReferral
  );
  const [showFormLoading, setShowFormLoading] = useState<boolean>(false);

  const [schemes, setSchemes] = useState(<></>);
  const [caseType, setcaseType] = useState(<></>);
  const [developments, setDevelopments] = useState(<></>);
  const [employmentStatuses, setEmploymentStatuses] = useState(<></>);
  const [propertyStatuses, setPropertyStatuses] = useState(<></>);
  const [propertyTypes, setPropertyTypes] = useState(<></>);
  const [buyerTypes, setBuyerTypes] = useState(<></>);
  const [stressTestingRentPayments, setStressTestingRentPayments] = useState(<></>);
  const [appointmentTypes, setappointmentTypes] = useState(<></>);

  const [showWillPropBeSold1, setShowWillPropBeSold1] = useState(false);
  const [showWillPropBeSold2, setShowWillPropBeSold2] = useState(false);
  const [cashBuyer, setCashBuyer] = useState(false);

  const [allowDraft, setAllowDraft] = useState(true);

  const validationMessage = "This field is required";

  // Initialise case referral
  useEffect(() => {
    let _caseReferral = caseReferral;

    if (caseReferral.applicants === undefined) {
      let _applicantArray = [];

      for (let i = 0; i < 2; i++) {
        var _applicantReferral = {} as ApplicantReferral;
        _applicantArray.push(_applicantReferral);
      }

      _caseReferral.applicants = _applicantArray;

      setCaseReferral(_caseReferral);
      setApplicantsLoaded(true);
    }
  }, [applicantsLoaded]);

  // Set up dropdown lists
  useEffect(() => {
    setShowFormLoading(true);
    var pCasetype = getCasetype();
    var pSchemes = getSchemes();
    var pDevelopments = getDevelopments();
    var pEmpStatuses = getEmploymentStatuses();
    var pPropStatuses = getPropertyStatuses();
    var pPropertyTypes = getPropertyTypes();
    var pBuyerTypes = getBuyerTypes();
    var pStressTestingRentPayments = getStressTestingRentPayments();
    var pAppointmentType = getappintmentTypes();

    Promise.allSettled([
      pSchemes,
      pDevelopments,
      pEmpStatuses,
      pPropStatuses,
      pPropertyTypes,
      pBuyerTypes,
      pStressTestingRentPayments,
      pAppointmentType,
      pCasetype
    ]).then(() => {
      setShowFormLoading(false);
    });
  }, []);



  const getCasetype=()=>{
    return new Promise<void>(function (resolve, reject) {
      globalDataRepo.GetLookupList(20).then(
        function (response: any) {
          var caseTypeList = response.map((d: any, index: any) => {
            return (
              <option style={{ fontSize: "12px" }} key={index} value={d.id}>
                {d.description}
              </option>
            );
          });

          setcaseType(caseTypeList);

          resolve();
        },
        function (error: any) {
          console.error(error);

          globalFunctions.HandleToast({
            header: "Error",
            id: "Scheme-Lookup-Error",
            description: "Could not load caseType",
            type: "danger",
            error: error,
          });

          reject();
        }
      );
    });
  }


  const getSchemes = () => {
    return new Promise<void>(function (resolve, reject) {
      globalDataRepo.GetLookupList(16).then(
        function (response: any) {
          var schemesList = response.map((d: any, index: any) => {
            return (
              <option style={{ fontSize: "12px" }} key={index} value={d.id}>
                {d.description}
              </option>
            );
          });

          setSchemes(schemesList);

          resolve();
        },
        function (error: any) {
          console.error(error);

          globalFunctions.HandleToast({
            header: "Error",
            id: "Scheme-Lookup-Error",
            description: "Could not load schemes",
            type: "danger",
            error: error,
          });

          reject();
        }
      );
    });
  };

  const getappintmentTypes = () => {
    return new Promise<void>(function (resolve, reject) {
      globalDataRepo.GetLookupList(19).then(
        function (response: any) {
    
          var appointmenttypeList = response.map((d: any, index: any) => {
            return (
              <option style={{ fontSize: "12px" }} key={index} value={d.id}>
                {d.description}
              </option>
            );
          });
          console.log(appointmenttypeList)
          setappointmentTypes(appointmenttypeList);
          resolve();
        },
        function (error: any) {
          console.error(error);

          globalFunctions.HandleToast({
            header: "Error",
            id: "Scheme-Lookup-Error",
            description: "Could not load schemes",
            type: "danger",
            error: error,
          });

          reject();
        }
      );
    });
  };




  const getDevelopments = () => {
    return new Promise<void>(function (resolve, reject) {
      var developmentsList: any = globalState.developments.map(
        (d: any, index: any) => {
          return (
            <option style={{ fontSize: "12px" }} key={index} value={d.id}>
              {d.name}
            </option>
          );
        }
      );

      setDevelopments(developmentsList);

      resolve();
    });
  };

  const getEmploymentStatuses = () => {
    return new Promise<void>(function (resolve, reject) {
      globalDataRepo.GetLookupList(7).then(
        function (response: any) {
          var esList = response.map((d: any, index: any) => {
            return (
              <option style={{ fontSize: "12px" }} key={index} value={d.id}>
                {d.description}
              </option>
            );
          });

          setEmploymentStatuses(esList);

          resolve();
        },
        function (error: any) {
          console.error(error);

          globalFunctions.HandleToast({
            header: "Error",
            id: "Employment-Status-Lookup-Error",
            description: "Could not load employment statuses",
            type: "danger",
            error: error,
          });

          reject();
        }
      );
    });
  };

  const getPropertyStatuses = () => {
    return new Promise<void>(function (resolve, reject) {
      globalDataRepo.GetLookupList(8).then(
        function (response: any) {
          var psList = response.map((d: any, index: any) => {
            return (
              <option style={{ fontSize: "12px" }} key={index} value={d.id}>
                {d.description}
              </option>
            );
          });

          setPropertyStatuses(psList);

          resolve();
        },
        function (error: any) {
          console.error(error);

          globalFunctions.HandleToast({
            header: "Error",
            id: "Property-Status-Lookup-Error",
            description: "Could not load property statuses",
            type: "danger",
            error: error,
          });

          reject();
        }
      );
    });
  };


  const getPropertyTypes = () => {
    return new Promise<void>(function (resolve, reject) {
      globalDataRepo.GetLookupList(17).then(
        function (response: any) {
          var ptList = response.map((d: any, index: any) => {
            return (
              <option style={{ fontSize: "12px" }} key={index} value={d.id}>
                {d.description}
              </option>
            );
          });

          setPropertyTypes(ptList);

          resolve();
        },
        function (error: any) {
          console.error(error);

          globalFunctions.HandleToast({
            header: "Error",
            id: "Property-Types-Lookup-Error",
            description: "Could not load property types",
            type: "danger",
            error: error,
          });

          reject();
        }
      );
    });
  };

  const getStressTestingRentPayments = () => {
    return new Promise<void>(function (resolve, reject) {
      globalDataRepo.GetLookupList(21).then(
        function (response: any) {
          var btList = response.map((d: any, index: any) => {
            return (
              <option style={{ fontSize: "12px" }} key={index} value={d.id}>
                {d.description}
              </option>
            );
          });

          setStressTestingRentPayments(btList);

          resolve();
        },
        function (error: any) {
          console.error(error);

          globalFunctions.HandleToast({
            header: "Error",
            id: "Stress-Testing-Rent-Payments-Lookup-Error",
            description: "Could not load Stress testing rent payments",
            type: "danger",
            error: error,
          });

          reject();
        }
      );
    });
  };

  const getBuyerTypes = () => {
    return new Promise<void>(function (resolve, reject) {
      globalDataRepo.GetLookupList(18).then(
        function (response: any) {
          var btList = response.map((d: any, index: any) => {
            return (
              <option style={{ fontSize: "12px" }} key={index} value={d.id}>
                {d.description}
              </option>
            );
          });

          setBuyerTypes(btList);

          resolve();
        },
        function (error: any) {
          console.error(error);

          globalFunctions.HandleToast({
            header: "Error",
            id: "Buyer-Types-Lookup-Error",
            description: "Could not load buyer types",
            type: "danger",
            error: error,
          });

          reject();
        }
      );
    });
  };

  const closeComplete = () => {
    props.onReferCaseComplete();
  };

  const applicantTabSelected = (_tab: number) => {
    setSelectedIndex(_tab);
  };

  const validate = (isDraft: boolean) => {
    console.log(isDraft);
    console.log("CaseReferral: " + JSON.stringify(caseReferral) )
    console.log(caseReferral.casetypeId)
    return new Promise<void>(function (resolve, reject) {
      var hasError = false;

      // Reset from previous validation
      setPropertyStatusIdInvalid(false);
      setDevelopmentIdInvalid(false);
      setPurchasePriceInvalid(false);
      setPlotNumberInvalid(false);
      setManagerNameInvalid(false);
      setDepositLevelInvalid(false);
      setServiceChargeInvalid(false);
      setCurrentShareholdingsInvalid(false);
      setremainingyearoncurrentleaseInvalid(false);
      setSchemeInvalid(false);
      setMinPercShareInvalid(false);
      setHousingAssociationInvalid(false);
      setApplicant1NameInvalid(false);
      setApplicant1PhoneInvalid(false);
      setApplicant1AddressInvalid(false);
      setApplicant1TownInvalid(false);
      setApplicant1PostcodeInvalid(false);
      setApplicant1EmploymentStatusInvalid(false);
      setApplicant1OtherPropertyOwnedInvalid(false);
      setApplicant1OtherPropertySoldInvalid(false);
      setPropertyTypeInvalid(false);
      setBuyerTypeInvalid(false);
      setAppointmentInvalid(false);
      setCasetypeInvalid(false);

      if (isDraft) {

      

        if (!caseReferral.casetypeId) {
          setCasetypeInvalid(true);
          hasError = true;
        }



        // if (!caseReferral.appointmentTypeId ) {
        //   setAppointmentInvalid(true);
        //   hasError = true;
     
        // }

        if (!caseReferral.applicants[0].applicantName) {
          setApplicant1NameInvalid(true);
          setSelectedIndex(0);
          hasError = true;
        }

        if (!caseReferral.purchasePrice) {
          setPurchasePriceInvalid(true);
          hasError = true;
        }

        if (!caseReferral.propertyStatusId) {
          setPropertyStatusIdInvalid(true);
          hasError = true;
        }

   

       

        if (!caseReferral.serviceCharge) {
          setServiceChargeInvalid(true);
          hasError = true;
        }

        if (!caseReferral.CurrentShareHolding) {
          setCurrentShareholdingsInvalid(true);
          hasError = true;
        }
        

        if (!caseReferral.propertyTypeId) {
          setPropertyTypeInvalid(true);
          hasError = true;
        }

        if (!caseReferral.CurrentShareHolding) {
          if(caseReferral.casetypeId===306){
          setCurrentShareholdingsInvalid(true);
          hasError = true;
        }else{
          setCurrentShareholdingsInvalid(false);
          hasError = false;
        }
        }

        if (!caseReferral.buyerTypeId) {
          if(caseReferral.casetypeId===305){
            setBuyerTypeInvalid(true);
            hasError = true;
           
          }else{
            setBuyerTypeInvalid(false);
            hasError = false;
        }
        }

        if (!caseReferral.developmentId) {
          if(caseReferral.casetypeId===305){
              setDevelopmentIdInvalid(true);
              hasError = true;
          }else{
            setDevelopmentIdInvalid(false);
            hasError = false;
          }
        }

        if (!caseReferral.depositLevel) {
          if(caseReferral.casetypeId===305){
          setDepositLevelInvalid(true);
          hasError = true;}else{
            setDepositLevelInvalid(false);
            hasError = false;
          }
        }
        if (!caseReferral.plotNumber) {
          if(caseReferral.casetypeId===305){
          setPlotNumberInvalid(true);
          hasError = true;}
          else{
            setPlotNumberInvalid(false);
            hasError = false;
          }
        }


        if (!caseReferral.schemeId) {
          console.log(caseReferral.casetypeId)
            if(caseReferral.casetypeId===305){
            setSchemeInvalid(true);
            hasError = true;
          }else{
            setSchemeInvalid(false);
            hasError = false;
          }
        }

        if (!caseReferral.remainingYearonCurrentLease) {
          if(caseReferral.casetypeId===306){
          setremainingyearoncurrentleaseInvalid(true);
        }
          hasError = true;
        }else{
          setremainingyearoncurrentleaseInvalid(false);
          hasError = false;
        
        }

      }

      if (!isDraft) {
        // Case


        if (!caseReferral.remainingYearonCurrentLease) {
          if(caseReferral.casetypeId===306){
          setremainingyearoncurrentleaseInvalid(true);
        }
          hasError = true;
        }else{
          setremainingyearoncurrentleaseInvalid(false);
          hasError = false;
        
        }
        if (!caseReferral.CurrentShareHolding) {
          if(caseReferral.casetypeId===306){
          setCurrentShareholdingsInvalid(true);
          hasError = true;
        }else{
          setCurrentShareholdingsInvalid(false);
          hasError = false;
        }
        }

        if (!caseReferral.buyerTypeId) {
          if(caseReferral.casetypeId===305){
            setBuyerTypeInvalid(true);
            hasError = true;
           
          }else{
            setBuyerTypeInvalid(false);
            hasError = false;
        }
        }

        if (!caseReferral.developmentId) {
          if(caseReferral.casetypeId===305){
              setDevelopmentIdInvalid(true);
              hasError = true;
          }else{
            setDevelopmentIdInvalid(false);
            hasError = false;
          }
        }

        if (!caseReferral.depositLevel) {
          if(caseReferral.casetypeId===305){
          setDepositLevelInvalid(true);
          hasError = true;}else{
            setDepositLevelInvalid(false);
            hasError = false;
          }
        }

        if (!caseReferral.plotNumber) {
          if(caseReferral.casetypeId===305){
          setPlotNumberInvalid(true);
          hasError = true;}
          else{
            setPlotNumberInvalid(false);
            hasError = false;
          }
        }


        if (!caseReferral.schemeId) {
          console.log(caseReferral.casetypeId)
            if(caseReferral.casetypeId===305){
            setSchemeInvalid(true);
            hasError = true;
          }else{
            setSchemeInvalid(false);
            hasError = false;
          }
        }


        console.log(caseReferral)
        if (!caseReferral.propertyStatusId) {
          setPropertyStatusIdInvalid(true);
          hasError = true;
        }

        // if (!caseReferral.developmentId) {
        //   setDevelopmentIdInvalid(true);
        //   hasError = true;
        // }

        if (!caseReferral.purchasePrice) {
          setPurchasePriceInvalid(true);
          hasError = true;
        }

        // if (!caseReferral.plotNumber) {
        //   setPlotNumberInvalid(true);
        //   hasError = true;
        // }

        if (!caseReferral.managerName) {
          setManagerNameInvalid(true);
          hasError = true;
        }

        // if (!caseReferral.depositLevel) {
        //   setDepositLevelInvalid(true);
        //   hasError = true;
        // }

        if (!caseReferral.serviceCharge) {
          setServiceChargeInvalid(true);
          hasError = true;
        }

        // if (!caseReferral.schemeId) {
        //   setSchemeInvalid(true);
        //   hasError = true;
        // }

        if (!caseReferral.casetypeId) {
          setCasetypeInvalid(true);
          hasError = true;
        }

        // if (!caseReferral.appointmentTypeId) {
        //   setAppointmentInvalid(true);
        //   hasError = true;
        // }

        if (!caseReferral.propertyTypeId) {
          setPropertyTypeInvalid(true);
          hasError = true;
        }

        // if (!caseReferral.buyerTypeId) {
        //   setBuyerTypeInvalid(true);
        //   hasError = true;
        // }

        // If its shared owndership, further checks are needed
        if (caseReferral.so === 1) {
          if (!caseReferral.minPercShareAvailable) {
            setMinPercShareInvalid(true);
            hasError = true;
          }

          if (!caseReferral.housingAssociation) {
            setHousingAssociationInvalid(true);
            hasError = true;
          }
        }

        // Applicant
        if (!caseReferral.applicants[0].applicantName) {
          setApplicant1NameInvalid(true);
          setSelectedIndex(0);
          hasError = true;
        }

        if (!caseReferral.applicants[0].applicantPhone1) {
          setApplicant1PhoneInvalid(true);
          setSelectedIndex(0);
          hasError = true;
        }

        if (!caseReferral.applicants[0].applicantAddress) {
          setApplicant1AddressInvalid(true);
          setSelectedIndex(0);
          hasError = true;
        }

        if (!caseReferral.applicants[0].applicantTown) {
          setApplicant1TownInvalid(true);
          setSelectedIndex(0);
          hasError = true;
        }

        if (!caseReferral.applicants[0].applicantPostcode) {
          setApplicant1PostcodeInvalid(true);
          setSelectedIndex(0);
          hasError = true;
        }

        if (!caseReferral.applicants[0].employmentStatusId) {
          setApplicant1EmploymentStatusInvalid(true);
          setSelectedIndex(0);
          hasError = true;
        }

        if (caseReferral.applicants[0].otherPropertyOwned === undefined) {

          console.log("SOLD BUG 1");
          console.log(caseReferral.applicants[0].willPropBeSold);


          setApplicant1OtherPropertyOwnedInvalid(true);
          setSelectedIndex(0);
          hasError = true;
        }

        if (caseReferral.applicants[0].otherPropertyOwned === 1 && caseReferral.applicants[0].willPropBeSold === undefined) {

          console.log("SOLD BUG 2");
          setApplicant1OtherPropertySoldInvalid(true);
          setSelectedIndex(0);
          hasError = true;
        }
      }

      if (hasError) {
        reject();
      } else {
        resolve();
      }
    });
  };

  const submitCase = (caseStatusId: number, isDraft: boolean) => {
    validate(isDraft).then(
      function () {

        var cr: CreateCase = {
          CaseStatusId: caseStatusId,
          DevelopmentId: caseReferral.developmentId,
          DeveloperId: 0, //set in API
          PurchasePrice: caseReferral.purchasePrice,
          PlotNumber: caseReferral.plotNumber,
          Htb: caseReferral.htb,
          CashBuyer: caseReferral.cashBuyer,
          So: caseReferral.so,
          KeyNotes: caseReferral.keyNotes,
          DateOfReferral: moment().toDate(),
          UpdatedDate: moment().toDate(),
          IsDeleted: caseReferral.isDeleted,
          AdvisorId: caseReferral.advisorId,
          PropertyStatusId: caseReferral.propertyStatusId,
          DepositLevel: caseReferral.depositLevel,
          ServiceCharge: caseReferral.serviceCharge,
          MinPercShareAvailable: caseReferral.minPercShareAvailable,
          HousingAssociation: caseReferral.housingAssociation,
          FinancialDetailsId: caseReferral.financialDetailsId,
          IsClosed: 0,
          AdministratorId: caseReferral.administratorId,
          LnhManagerId: caseReferral.lnhManagerId,
          SchemeId: caseReferral.schemeId,
          PropertyTypeId: caseReferral.propertyTypeId,
          BuyerTypeId: caseReferral.buyerTypeId,
          managerName: caseReferral.managerName,
          appointmentTypeId:caseReferral.appointmentTypeId,
          casetypeId:caseReferral.casetypeId,
          CurrentShareHolding: caseReferral.CurrentShareHolding,
          remainingYearonCurrentLease: caseReferral.remainingYearonCurrentLease,
          strpTypeId: caseReferral.strpTypeId  
        };
console.log(cr)
        globalDataRepo.CreateCase(cr).then(
          function (caseResponse: any) {
            caseReferral.applicants[0].jmCaseId = caseResponse.id;
            caseReferral.applicants[1].jmCaseId = caseResponse.id;

            globalDataRepo.CreateApplicant(caseReferral.applicants[0]).then(
              function (app1Response: any) {
                globalDataRepo.CreateApplicant(caseReferral.applicants[1]).then(
                  function (app2Response: any) {
                    globalFunctions.HandleToast({
                      header: "Case submitted",
                      id: "Refer-Case-Success",
                      description: "Thank you, your case has been submitted.",
                      type: "success",
                      error: "",
                    });

                    props.onReferCaseComplete();
                  },
                  function (error: any) {
                    globalFunctions.HandleToast({
                      header: "Error",
                      id: "Create-Applicant-Error",
                      description:
                        "Something went wrong. Could not create applicant.",
                      type: "danger",
                      error: error,
                    });
                  }
                );
              },
              function (error: any) {
                globalFunctions.HandleToast({
                  header: "Error",
                  id: "Create-Applicant-Error",
                  description:
                    "Something went wrong. Could not create applicant.",
                  type: "danger",
                  error: error,
                });
              }
            );
          },
          function (error: any) {
            globalFunctions.HandleToast({
              header: "Error",
              id: "Refer-Case-Error",
              description: "Something went wrong. Could not refer case.",
              type: "danger",
              error: error,
            });
          }
        );
      },
      function (error) { }
    );
  };

  const handleAdd = () => {
    submitCase(25, false);
  };

  const handleDraftCopy = () => {
    submitCase(66, true);
  };

  const handleUpdate = () => {
    // formTitle is always "add" so this function will never be called.
    // Left in here in case we want to add this functionality later.
  };

  const tabs = ["Applicant 1", "Applicant 2"];

  return (
    <SideSheet
      isShown={true}
      containerProps={{
        display: "flex",
        flex: "1",
        flexDirection: "column",
        marginTop: "90px !important",
        width: "100%",
        height: "100%",
        paddingBottom: "20px",
        overflowY: "auto",
      }}
      width={"100%"}
    >
      <Pane
        overflowY="auto"
        zIndex={1}
        flexShrink={0}
        elevation={0}
        backgroundColor="white"
      >
        <Pane padding={32} paddingTop={16} paddingBottom={16}>
          <Pane display="flex" marginBottom={10}>
            <Icon
              icon={BriefcaseIcon}
              size={25}
              marginRight={10}
              color="#234361"
            />
            <Heading size={600}>Refer New Case</Heading>
          </Pane>
          <Paragraph size={400}>
            All mandatory fields must be complete before you can refer a new
            case
          </Paragraph>
        </Pane>
      </Pane>

      



      {applicantsLoaded === true ? (
        <Pane flex="1" overflowY="auto" background="tint1" padding={20}>

          <Pane display={selectedIndex === 0 ? "flex" : "none"}>
          <Row style={{ width: "100%" }}>
          <Col
            xs={12}
            sm={12}
            md={4}
            lg={4}
            style={{ marginBottom: "20px" }}>
                <SelectField
                    label="Case Type"
                    required
                    width="100%"
                    marginBottom={24}
                  
                    onChange={(e: any) => {
                      var _selectedCase = { ...caseReferral };
                      console.log(_selectedCase)
                      _selectedCase.casetypeId = Number(e.target.value);
                      // _selectedCase.schemeId = Number(e.target.value);
                      // _selectedCase.so = Number(e.target.value) === 171 ? 1 : 0;
                       setCaseReferral(_selectedCase);
                    }}
                    value={caseReferral?.casetypeId}
                    isInvalid={casetypeInvalid}
                    validationMessage={casetypeInvalid ? validationMessage : null}
                  >
                    <option value="">Please Select...</option>
                    {caseType}
               
                  </SelectField>
          </Col>
          </Row>
          </Pane>

          {caseReferral.casetypeId === 305 || caseReferral.casetypeId === 306  ? (<>
          
            <Row>
            <Col xs={12} sm={12} md={9} lg={9} style={{ marginBottom: "20px" }}>
              <Pane
                elevation={1}
                marginRight="1%"
                style={{
                  padding: "20px",
                  border: "1px solid lightgray",
                  borderRadius: "10px",
                  paddingBottom: "0px",
                }}
              >
                <Tablist marginBottom={16} flexBasis={240} marginRight={24}>
                  {tabs.map((tab, index) => (
                    <Tab
                      key={tab}
                      id={tab}
                      onSelect={() => applicantTabSelected(index)}
                      isSelected={index === selectedIndex}
                      aria-controls={`panel-${tab}`}
                      style={{ fontSize: "16px" }}
                    >
                      {tab}
                    </Tab>
                  ))}
                </Tablist>



                <Pane display={selectedIndex === 0 ? "flex" : "none"}>
                  <Row style={{ width: "100%" }}>
                    <Col
                      xs={12}
                      sm={12}
                      md={4}
                      lg={4}
                      style={{ marginBottom: "20px" }}
                    >
                      <TextInputField
                        label="Name"
                        required
                        value={caseReferral?.applicants[0]?.applicantName || ""}
                        onChange={(e: any) => {
                          var _selectedCase = { ...caseReferral };
                          var _applicant1 = _selectedCase.applicants[0];
                          _applicant1.applicantName = e.target.value;
                          _selectedCase.applicants[0] = _applicant1;
                          setCaseReferral(_selectedCase);
                        }}
                        isInvalid={applicant1NameInvalid}
                        validationMessage={
                          applicant1NameInvalid ? validationMessage : null
                        }
                      />
                      <TextInputField
                        label="Email Address"
                        value={caseReferral?.applicants[0]?.applicantEmail || ""}
                        onChange={(e: any) => {
                          var _selectedCase = { ...caseReferral };
                          var _applicant1 = _selectedCase.applicants[0];
                          _applicant1.applicantEmail = e.target.value;
                          _selectedCase.applicants[0] = _applicant1;
                          setCaseReferral(_selectedCase);
                        }}
                      />
                      <TextInputField
                        label="Primary Phone"
                        required
                        value={caseReferral?.applicants[0]?.applicantPhone1 || ""}
                        onChange={(e: any) => {
                          var _selectedCase = { ...caseReferral };
                          var _applicant1 = _selectedCase.applicants[0];
                          _applicant1.applicantPhone1 = e.target.value;
                          _selectedCase.applicants[0] = _applicant1;
                          setCaseReferral(_selectedCase);
                        }}
                        isInvalid={applicant1PhoneInvalid}
                        validationMessage={
                          applicant1PhoneInvalid ? validationMessage : null
                        }
                      />
                      <TextInputField
                        label="Secondary Phone"
                        value={caseReferral?.applicants[0]?.applicantPhone2 || ""}
                        onChange={(e: any) => {
                          var _selectedCase = { ...caseReferral };
                          var _applicant1 = _selectedCase.applicants[0];
                          _applicant1.applicantPhone2 = e.target.value;
                          _selectedCase.applicants[0] = _applicant1;
                          setCaseReferral(_selectedCase);
                        }}
                      />
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={4}
                      lg={4}
                      style={{ marginBottom: "20px" }}
                    >
                      <TextInputField
                        label="Address"
                        required
                        value={caseReferral?.applicants[0]?.applicantAddress || ""}
                        onChange={(e: any) => {
                          var _selectedCase = { ...caseReferral };
                          var _applicant1 = _selectedCase.applicants[0];
                          _applicant1.applicantAddress = e.target.value;
                          _selectedCase.applicants[0] = _applicant1;
                          setCaseReferral(_selectedCase);
                        }}
                        isInvalid={applicant1AddressInvalid}
                        validationMessage={
                          applicant1AddressInvalid ? validationMessage : null
                        }
                      />
                      <TextInputField
                        label="Town"
                        required
                        value={caseReferral?.applicants[0]?.applicantTown || ""}
                        onChange={(e: any) => {
                          var _selectedCase = { ...caseReferral };
                          var _applicant1 = _selectedCase.applicants[0];
                          _applicant1.applicantTown = e.target.value;
                          _selectedCase.applicants[0] = _applicant1;
                          setCaseReferral(_selectedCase);
                        }}
                        isInvalid={applicant1TownInvalid}
                        validationMessage={
                          applicant1TownInvalid ? validationMessage : null
                        }
                      />
                      <TextInputField
                        label="County"
                        value={caseReferral?.applicants[0]?.applicantCounty || ""}
                        onChange={(e: any) => {
                          var _selectedCase = { ...caseReferral };
                          var _applicant1 = _selectedCase.applicants[0];
                          _applicant1.applicantCounty = e.target.value;
                          _selectedCase.applicants[0] = _applicant1;
                          setCaseReferral(_selectedCase);
                        }}
                      />
                      <TextInputField
                        label="Postcode"
                        required
                        value={caseReferral?.applicants[0]?.applicantPostcode || ""}
                        onChange={(e: any) => {
                          var _selectedCase = { ...caseReferral };
                          var _applicant1 = _selectedCase.applicants[0];
                          _applicant1.applicantPostcode = e.target.value;
                          _selectedCase.applicants[0] = _applicant1;
                          setCaseReferral(_selectedCase);
                        }}
                        isInvalid={applicant1PostcodeInvalid}
                        validationMessage={
                          applicant1PostcodeInvalid ? validationMessage : null
                        }
                      />
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={4}
                      lg={4}
                      style={{ marginBottom: "20px" }}
                    >
                      <SelectField
                        label="Employment Status"
                        onChange={(e: any) => {
                          var _selectedCase = { ...caseReferral };
                          var _applicant1 = _selectedCase.applicants[0];
                          _applicant1.employmentStatusId = Number(
                            e.target.value
                          );
                          _selectedCase.applicants[0] = _applicant1;
                          setCaseReferral(_selectedCase);
                        }}
                        value={caseReferral?.applicants[0]?.employmentStatusId}
                        required
                        width="100%"
                        isInvalid={applicant1EmploymentStatusInvalid}
                        validationMessage={
                          applicant1EmploymentStatusInvalid
                            ? validationMessage
                            : null
                        }
                        marginBottom={24}
                      >
                        <option value="">Please Select...</option>
                        {employmentStatuses}
                      </SelectField>
                      <SelectField
                        label="Other Property Owned?"
                        onChange={(e: any) => {
                          var _selectedCase = { ...caseReferral };
                          var _applicant1 = _selectedCase.applicants[0];
                          _applicant1.otherPropertyOwned = Number(
                            e.target.value
                          );
                          _selectedCase.applicants[0] = _applicant1;
                          setCaseReferral(_selectedCase);
                          setShowWillPropBeSold1(Number(e.target.value) === 1);
                        }}
                        value={caseReferral.applicants[0].otherPropertyOwned}
                        required
                        width="100%"
                        isInvalid={applicant1OtherPropertyOwnedInvalid}
                        validationMessage={
                          applicant1OtherPropertyOwnedInvalid
                            ? validationMessage
                            : null
                        }
                        marginBottom={24}
                      >
                        <option value="">Please Select...</option>
                        <option style={{ fontSize: "12px" }} key={0} value={0}>
                          No
                        </option>
                        <option style={{ fontSize: "12px" }} key={1} value={1}>
                          Yes
                        </option>
                      </SelectField>
                      {showWillPropBeSold1 ? (
                        <SelectField
                          label="Will Property Be Sold?"
                          onChange={(e: any) => {
                            var _selectedCase = { ...caseReferral };
                            var _applicant1 = _selectedCase.applicants[0];
                            _applicant1.willPropBeSold = Number(e.target.value);
                            _selectedCase.applicants[0] = _applicant1;
                            setCaseReferral(_selectedCase);
                          }}
                          isInvalid={applicant1OtherPropertySoldInvalid}
                          validationMessage={
                            applicant1OtherPropertySoldInvalid
                              ? validationMessage
                              : null
                          }
                          value={caseReferral?.applicants[0]?.willPropBeSold}
                          required
                          width="100%"
                          marginBottom={24}
                        >
                          <option value=""></option>
                          <option
                            style={{ fontSize: "12px" }}
                            key={0}
                            value={0}
                          >
                            No
                          </option>
                          <option
                            style={{ fontSize: "12px" }}
                            key={1}
                            value={1}
                          >
                            Yes
                          </option>
                        </SelectField>
                      ) : null}
                    </Col>
                  </Row>
                </Pane>
                <Pane display={selectedIndex === 1 ? "flex" : "none"}>
                  <Row style={{ width: "100%" }}>
                    <Col
                      xs={12}
                      sm={12}
                      md={4}
                      lg={4}
                      style={{ marginBottom: "20px" }}
                    >
                      <TextInputField
                        label="Name"
                        value={caseReferral?.applicants[1]?.applicantName || ""}
                        onChange={(e: any) => {
                          var _selectedCase = { ...caseReferral };
                          var _applicant1 = _selectedCase.applicants[1];
                          _applicant1.applicantName = e.target.value;
                          _selectedCase.applicants[1] = _applicant1;
                          setCaseReferral(_selectedCase);
                        }}
                      />
                      <TextInputField
                        label="Email Address"
                        value={caseReferral?.applicants[1]?.applicantEmail || ""}
                        onChange={(e: any) => {
                          var _selectedCase = { ...caseReferral };
                          var _applicant1 = _selectedCase.applicants[1];
                          _applicant1.applicantEmail = e.target.value;
                          _selectedCase.applicants[1] = _applicant1;
                          setCaseReferral(_selectedCase);
                        }}
                      />
                      <TextInputField
                        label="Primary Phone"
                        value={caseReferral?.applicants[1]?.applicantPhone1 || ""}
                        onChange={(e: any) => {
                          var _selectedCase = { ...caseReferral };
                          var _applicant1 = _selectedCase.applicants[1];
                          _applicant1.applicantPhone1 = e.target.value;
                          _selectedCase.applicants[1] = _applicant1;
                          setCaseReferral(_selectedCase);
                        }}
                      />
                      <TextInputField
                        label="Secondary Phone"
                        value={caseReferral?.applicants[1]?.applicantPhone2 || ""}
                        onChange={(e: any) => {
                          var _selectedCase = { ...caseReferral };
                          var _applicant1 = _selectedCase.applicants[1];
                          _applicant1.applicantPhone2 = e.target.value;
                          _selectedCase.applicants[1] = _applicant1;
                          setCaseReferral(_selectedCase);
                        }}
                      />
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={4}
                      lg={4}
                      style={{ marginBottom: "20px" }}
                    >
                      <TextInputField
                        label="Address"
                        value={caseReferral?.applicants[1]?.applicantAddress || ""}
                        onChange={(e: any) => {
                          var _selectedCase = { ...caseReferral };
                          var _applicant1 = _selectedCase.applicants[1];
                          _applicant1.applicantAddress = e.target.value;
                          _selectedCase.applicants[1] = _applicant1;
                          setCaseReferral(_selectedCase);
                        }}
                      />
                      <TextInputField
                        label="Town"
                        value={caseReferral?.applicants[1]?.applicantTown || ""}
                        onChange={(e: any) => {
                          var _selectedCase = { ...caseReferral };
                          var _applicant1 = _selectedCase.applicants[1];
                          _applicant1.applicantTown = e.target.value;
                          _selectedCase.applicants[1] = _applicant1;
                          setCaseReferral(_selectedCase);
                        }}
                      />
                      <TextInputField
                        label="County"
                        value={caseReferral?.applicants[1]?.applicantCounty || ""}
                        onChange={(e: any) => {
                          var _selectedCase = { ...caseReferral };
                          var _applicant1 = _selectedCase.applicants[1];
                          _applicant1.applicantCounty = e.target.value;
                          _selectedCase.applicants[1] = _applicant1;
                          setCaseReferral(_selectedCase);
                        }}
                      />
                      <TextInputField
                        label="Postcode"
                        value={caseReferral?.applicants[1]?.applicantPostcode || ""}
                        onChange={(e: any) => {
                          var _selectedCase = { ...caseReferral };
                          var _applicant1 = _selectedCase.applicants[1];
                          _applicant1.applicantPostcode = e.target.value;
                          _selectedCase.applicants[1] = _applicant1;
                          setCaseReferral(_selectedCase);
                        }}
                      />
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={4}
                      lg={4}
                      style={{ marginBottom: "20px" }}
                    >
                      <SelectField
                        label="Employment Status"
                        onChange={(e: any) => {
                          var _selectedCase = { ...caseReferral };
                          var _applicant1 = _selectedCase.applicants[1];
                          _applicant1.employmentStatusId = Number(
                            e.target.value
                          );
                          _selectedCase.applicants[1] = _applicant1;
                          setCaseReferral(_selectedCase);
                        }}
                        value={caseReferral?.applicants[1]?.employmentStatusId}
                        width="100%"
                        marginBottom={24}
                      >
                        <option value=""></option>
                        {employmentStatuses}
                      </SelectField>
                      <SelectField
                        label="Other Property Owned?"
                        onChange={(e: any) => {
                          var _selectedCase = { ...caseReferral };
                          var _applicant1 = _selectedCase.applicants[1];
                          _applicant1.otherPropertyOwned = Number(
                            e.target.value
                          );
                          _selectedCase.applicants[1] = _applicant1;
                          setCaseReferral(_selectedCase);
                          setShowWillPropBeSold2(Number(e.target.value) === 1);
                        }}
                        value={caseReferral?.applicants[1]?.otherPropertyOwned}
                        width="100%"
                        marginBottom={24}
                      >
                        <option value=""></option>
                        <option style={{ fontSize: "12px" }} key={0} value={0}>
                          No
                        </option>
                        <option style={{ fontSize: "12px" }} key={1} value={1}>
                          Yes
                        </option>
                      </SelectField>
                      {showWillPropBeSold2 ? (
                        <SelectField
                          label="Will Property Be Sold?"
                          onChange={(e: any) => {
                            var _selectedCase = { ...caseReferral };
                            var _applicant1 = _selectedCase.applicants[1];
                            _applicant1.willPropBeSold = Number(e.target.value);
                            _selectedCase.applicants[1] = _applicant1;
                            setCaseReferral(_selectedCase);
                          }}
                          value={caseReferral?.applicants[1]?.willPropBeSold}
                          width="100%"
                          marginBottom={24}
                        >
                          <option value="">Please Select...</option>
                          <option
                            style={{ fontSize: "12px" }}
                            key={0}
                            value={0}
                          >
                            No
                          </option>
                          <option
                            style={{ fontSize: "12px" }}
                            key={1}
                            value={1}
                          >
                            Yes
                          </option>
                        </SelectField>
                      ) : null}
                    </Col>
                  </Row>
                </Pane>
              </Pane>
            </Col>
            <Col xs={12} sm={12} md={3} lg={3}>
              <Pane
                elevation={1}
                style={{
                  padding: "20px",
                  border: "1px solid lightgray",
                  borderRadius: "10px",
                  paddingBottom: "0px",
                }}
              >
                <Heading
                  size={300}
                  marginTop="default"
                  style={{
                    marginBottom: "20px",
                    lineHeight: "20px",
                    marginTop: "0px",
                    fontSize: "16px",
                    color: "#425A70",
                    fontWeight: "500",
                  }}
                >
                  Key Notes
                </Heading>
                <Textarea
                  id="textarea"
                  placeholder="Any key notes to be added here..."
                  height={310}
                  value={caseReferral?.keyNotes || ""}
                  onChange={(e: any) => {
                    var _selectedCase = { ...caseReferral };
                    _selectedCase.keyNotes = e.target.value;
                    setCaseReferral(_selectedCase);
                  }}
                  marginBottom={24}
                />
              </Pane>
            </Col>
          </Row>
          <Row
            style={{
              marginTop: "20px",
              marginLeft: "0px",
              marginRight: "0px",
              boxShadow:
                "box-shadow: 0 0 1px rgb(67 90 111 / 30%), 0 2px 4px -2px rgb(67 90 111 / 47%)",
              padding: "20px",
              border: "1px solid lightgray",
              borderRadius: "10px",
              paddingLeft: "0px",
              paddingRight: "0px",
            }}
          >
            <Col
              xs={12}
              sm={12}
              md={6}
              lg={6}
              style={{ paddingLeft: "0px", paddingRight: "0px" }}
            >
              <Row style={{ marginLeft: "0px", marginRight: "0px" }}>
                <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  style={{ paddingLeft: "20px", paddingRight: "20px" }}
                >
                  <SelectField
                    label="Property Status"
                    onChange={(e: any) => {
                      var _selectedCase = { ...caseReferral };
                      _selectedCase.propertyStatusId = Number(e.target.value);
                      setCaseReferral(_selectedCase);
                    }}
                    value={caseReferral?.propertyStatusId}
                    required
                    width="100%"
                    isInvalid={propertyStatusIdInvalid}
                    validationMessage={
                      propertyStatusIdInvalid ? validationMessage : null
                    }
                    marginBottom={24}
                  >
                    <option value="">Please Select...</option>
                    {propertyStatuses}
                  </SelectField>

                {
                 caseReferral.casetypeId === 305 ? (<SelectField
                  label="Development Name"
                  onChange={(e: any) => {
                    var _selectedCase = { ...caseReferral };
                    _selectedCase.developmentId = Number(e.target.value);
                    setCaseReferral(_selectedCase);
                  }}
                  value={caseReferral?.developmentId}
                  required
                  width="100%"
                  isInvalid={developmentIdInvalid}
                  validationMessage={
                    developmentIdInvalid ? validationMessage : null
                  }
                  marginBottom={24}
                >
                  <option value="">Please Select...</option>
                  {developments}
                </SelectField>):null
                 
                 }
                
                  {/* <SelectField
                    label="Development Name"
                    onChange={(e: any) => {
                      var _selectedCase = { ...caseReferral };
                      _selectedCase.developmentId = Number(e.target.value);
                      setCaseReferral(_selectedCase);
                    }}
                    value={caseReferral?.developmentId}
                    required
                    width="100%"
                    isInvalid={developmentIdInvalid}
                    validationMessage={
                      developmentIdInvalid ? validationMessage : null
                    }
                    marginBottom={24}
                  >
                    <option value="">Please Select...</option>
                    {developments}
                  </SelectField> */}

                  <TextInputField
                    label="Manager"
                    required
                    value={caseReferral?.managerName || ""}
                    onChange={(e: any) => {
                      var _selectedCase = { ...caseReferral };
                      _selectedCase.managerName = e.target.value;
                      setCaseReferral(_selectedCase);
                    }}
                    isInvalid={managerNameInvalid}
                    validationMessage={
                      managerNameInvalid ? validationMessage : null
                    }
                  />
                 {
                 caseReferral.casetypeId === 305? (
                  <>
                  <Heading
                    size={300}
                    marginTop="default"
                    style={{
                      marginBottom: "10px",
                      lineHeight: "20px",
                      marginTop: "0px",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    Cash Buyer?
                  </Heading>
                  <Checkbox
                    marginLeft={15}
                    marginTop={2}
                    label="Yes"
                    checked={cashBuyer}
                    onChange={(e: any) => {
                      var _selectedCase = { ...caseReferral };
                      _selectedCase.cashBuyer = e.target.checked ? 1 : 0;
                      setCaseReferral(_selectedCase);
                      setCashBuyer(e.target.checked ? true : false);
                    }}
                  /></>):null}
                </Col>
                <Col xs={12} sm={12} md={6} lg={6}>
                  <div className="currency-wrap">
                    <span className="currency-code">£</span>
                    <TextInputField
                      className="text-currency"
                      label="Full Market Value"
                      type="number"
                      required
                      value={caseReferral?.purchasePrice || ""}
                      onChange={(e: any) => {
                        var _selectedCase = { ...caseReferral };
                        _selectedCase.purchasePrice = e.target.value;
                        setCaseReferral(_selectedCase);
                      }}
                      isInvalid={purchasePriceInvalid}
                      validationMessage={
                        purchasePriceInvalid ? validationMessage : null
                      }
                    />
                  </div>

                  {
                 caseReferral.casetypeId === 305?
                  <TextInputField
                    label="Property Plot Number"
                    required
                    value={caseReferral?.plotNumber || ""}
                    onChange={(e: any) => {
                      var _selectedCase = { ...caseReferral };
                      _selectedCase.plotNumber = e.target.value;
                      setCaseReferral(_selectedCase);
                    }}
                    isInvalid={plotNumberInvalid}
                    validationMessage={
                      plotNumberInvalid ? validationMessage : null
                    }
                  />:null}

                {
                 caseReferral.casetypeId === 305?
                  <SelectField
                    label="Buyer Type"
                    width="100%"
                    required
                    isInvalid={buyerTypeInvalid}
                    validationMessage={buyerTypeInvalid ? validationMessage : null}
                    value={caseReferral?.buyerTypeId}
                    onChange={(e: any) => {
                      var _selectedCase = { ...caseReferral };
                      _selectedCase.buyerTypeId = e.target.value;
                      setCaseReferral(_selectedCase);
                    }}
                  >
                    <option value="">Please Select...</option>
                    {buyerTypes}
                  </SelectField>:null}
                </Col>
              </Row>

              {/* <Row
                style={{
                  marginLeft: "20px",
                  marginRight: "20px",
                  marginBottom: "10px",
                }}
              >
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  style={{
                    display: "inline-flex",
                    paddingLeft: "0px",
                    paddingRight: "0px",
                  }}
                >
                  <Heading
                    size={300}
                    marginTop="default"
                    style={{
                      marginBottom: "4px",
                      lineHeight: "20px",
                      marginTop: "0px",
                      fontSize: "14px",
                      color: "#425A70",
                      fontWeight: "500",
                    }}
                  >
                    Cash Buyer?
                  </Heading>
                  <Checkbox
                    marginLeft={15}
                    marginTop={2}
                    label="Yes"
                    checked={cashBuyer}
                    onChange={(e: any) => {
                      var _selectedCase = { ...caseReferral };
                      _selectedCase.cashBuyer = e.target.checked ? 1 : 0;
                      setCaseReferral(_selectedCase);
                      setCashBuyer(e.target.checked ? true : false);
                    }}
                  />
                </Col> 
              </Row> */}
            </Col>

            <Col
              xs={12}
              sm={12}
              md={6}
              lg={6}
              style={{ paddingLeft: "20px", paddingRight: "20px" }}
            >
              <Row>
                <Col xs={12} sm={12} md={6} lg={6}>

                {
                 caseReferral.casetypeId === 305? (
                <>
                <div className="currency-wrap">
                    <span className="currency-code">£</span>
                    <TextInputField
                      className="text-currency"
                      label="Deposit Level (£)"
                      required
                      type="number"
                      value={caseReferral?.depositLevel || ""}
                      onChange={(e: any) => {
                        var _selectedCase = { ...caseReferral };
                        _selectedCase.depositLevel = e.target.value;
                        setCaseReferral(_selectedCase);
                      }}
                      isInvalid={depositLevelInvalid}
                      validationMessage={
                        depositLevelInvalid ? validationMessage : null
                      }
                    />
                  </div>
                 </>):null}
                 <div className="currency-wrap">
                    <span className="currency-code">£</span>
                    <TextInputField
                      className="text-currency"
                      label="Monthly Service Charge / Other Fees"
                      type="number"
                      required
                      value={caseReferral?.serviceCharge || ""}
                      onChange={(e: any) => {
                        var _selectedCase = { ...caseReferral };
                        _selectedCase.serviceCharge = e.target.value;
                        setCaseReferral(_selectedCase);
                      }}
                      isInvalid={serviceChargeInvalid}
                      validationMessage={
                        serviceChargeInvalid ? validationMessage : null
                      }
                    />
                  </div>



                  <SelectField
                    label="Property Type"
                    width="100%"
                    required
                    isInvalid={propertyTypeInvalid}
                    validationMessage={propertyTypeInvalid ? validationMessage : null}
                    value={caseReferral?.propertyTypeId}
                    onChange={(e: any) => {
                      var _selectedCase = { ...caseReferral };
                      _selectedCase.propertyTypeId = e.target.value;
                      setCaseReferral(_selectedCase);
                    }}
                  >
                    <option value="">Please Select...</option>
                    {propertyTypes}
                  </SelectField>
                </Col>
                <Col xs={12} sm={12} md={6} lg={6}>
                {
                 caseReferral.casetypeId === 305? (
                  <SelectField
                    label="Homes Purchase Scheme"
                    onChange={(e: any) => {
                      var _selectedCase = { ...caseReferral };
                      _selectedCase.schemeId = Number(e.target.value);
                      _selectedCase.so = Number(e.target.value) === 171 ? 1 : 0;
                      setCaseReferral(_selectedCase);
                    }}
                    value={caseReferral?.schemeId}
                    required
                    width="100%"
                    marginBottom={24}
                    isInvalid={schemeInvalid}
                    validationMessage={schemeInvalid ? validationMessage : null}
                  >
                    <option value="">Please Select...</option>
                    {schemes}
                  </SelectField>):null}

{/* 
                  <SelectField
                    label="Appointment Type"
                    onChange={(e: any) => {
                      var _selectedCase = { ...caseReferral };
                      _selectedCase.appointmentTypeId = Number(e.target.value);
                      setCaseReferral(_selectedCase);
                    }}
                    value={caseReferral?.appointmentTypeId}
                    required
                    width="100%"
                    marginBottom={24}
                    isInvalid={appointmentInvalid}
                    validationMessage={appointmentInvalid ? validationMessage : null}
                  >
                    <option value="">Please Select...</option>
                    {appointmentTypes}
                  </SelectField> */}
                  {
                    caseReferral.casetypeId === 306? (
                      <>
                     <div className="currency-wrap">
                     <span className="currency-code">%</span>
                     <TextInputField
                       className="text-currency"
                       label="Current % Shareholding"                   
                       type="number"
                       required
                       value={caseReferral?.CurrentShareHolding || ""}
                       onChange={(e: any) => {
                         var _selectedCase = { ...caseReferral };
                         _selectedCase.CurrentShareHolding = e.target.value;
                         setCaseReferral(_selectedCase);
                       }}
                       isInvalid={currentShareholdingsInvalid}
                       validationMessage={
                        currentShareholdingsInvalid ? validationMessage : null
                       }
                     />
                   </div></>):null
                  }

{/* remainingYearonCurrentLease */}


              {
                    caseReferral.casetypeId === 306? (
                      <>
                     <div className="currency-wrap">
                     <TextInputField
                       className="text-currency"
                       label="Remaining Years on Current Lease"                   
                       type="number"
                       required
                       value={caseReferral?.remainingYearonCurrentLease || ""}
                       onChange={(e: any) => {
                         var _selectedCase = { ...caseReferral };
                         _selectedCase.remainingYearonCurrentLease = e.target.value;
                         setCaseReferral(_selectedCase);
                       }}
                       isInvalid={remainingyearoncurrentleaseInvalid}
                       validationMessage={
                        remainingyearoncurrentleaseInvalid ? validationMessage : null
                       }
                     />
                   </div></>):null
                  }


                  {caseReferral.so === 1 ? (
                     <div className="currency-wrap">
                      <span className="currency-code">%</span>
                    <TextInputField
                      label="Min % Share Available"
                      className="text-currency"
                      value={caseReferral?.minPercShareAvailable || ""}
                      onChange={(e: any) => {
                        var _selectedCase = { ...caseReferral };
                        _selectedCase.minPercShareAvailable = e.target.value;
                        setCaseReferral(_selectedCase);
                      }}
                      isInvalid={minPercShareInvalid}
                      validationMessage={
                        minPercShareInvalid ? validationMessage : null
                      }
                      required
                    />
                    </div>
                  ) : null}
                  {caseReferral.so === 1 ? (
                    <TextInputField
                      style={{ marginBottom: "0px" }}
                      label="Housing Association"
                      value={caseReferral?.housingAssociation || ""}
                      onChange={(e: any) => {
                        var _selectedCase = { ...caseReferral };
                        _selectedCase.housingAssociation = e.target.value;
                        setCaseReferral(_selectedCase);
                      }}
                      isInvalid={housingAssociationInvalid}
                      validationMessage={
                        housingAssociationInvalid ? validationMessage : null
                      }
                      required
                    />
                  ) : null}

                  <SelectField
                      label="Stress Testing Rent Payments"
                      width="100%"
                      onChange={(e: any) => {
                        var _selectedCase = { ...caseReferral };
                        _selectedCase.strpTypeId = Number(e.target.value);
                        setCaseReferral(_selectedCase);
                      }}
                      value={caseReferral?.strpTypeId}
                      marginBottom={24}
               
                    >
                      <option value="">Please Select...</option>
                      {stressTestingRentPayments}
                    </SelectField>
                </Col>
              </Row>
            </Col>
          </Row>
          
          </>):null}

       
          <Pane display="flex" float="right" marginTop={20} marginBottom={70}>
            {allowDraft ? (
              <Button
                paddingLeft={35}
                marginRight={16}
                appearance="primary"
                intent="warning"
                iconBefore={FloppyDiskIcon}
                width={122}
                onClick={() => handleDraftCopy()}
                style={{
                  background: "rgb(152, 0, 83)",
                  border: "rgb(152, 0, 83)",
                  paddingLeft: "20px",
                }}
              >
                Save as draft
              </Button>
            ) : null}
            <Button
              paddingLeft={35}
              marginRight={16}
              appearance="primary"
              intent="danger"
              iconBefore={TrashIcon}
              width={122}
              onClick={() => closeComplete()}
              style={{
                paddingLeft: "20px",
              }}
            >
              Cancel
            </Button>
            <Button
              appearance="primary"
              intent="success"
              iconBefore={AddIcon}
              width={122}
              paddingLeft={21}
              onClick={
                props.formTitle === "Add"
                  ? () => handleAdd()
                  : () => handleUpdate()
              }
            >
              {props.formTitle === "Add" ? "Refer Case" : "Update Case"}
            </Button>
          </Pane>
        </Pane>
      ) : null}
      {showFormLoading ? (
        <Pane
          display="flex"
          alignItems="center"
          justifyContent="center"
          height="100%"
          background="rgba(0,0,0,0.05)"
          style={{ position: "absolute", width: "100%", top: "0" }}
        >
          <Spinner></Spinner>
        </Pane>
      ) : null}
    </SideSheet>
  );
};
